package org.catharsis.spendtel.feature.share

import kotlinx.serialization.Serializable
import org.catharsis.spendtel.feature.data.SpendingEquivalence

@Serializable
data class PublicShareSnapshot(
    val personalityLabel: String? = null,
    val personalityDescription: String? = null,
    val headline: String? = null,
    val periodLabel: String? = null,
    val goalUsed: String? = null,
    val highlights: List<String> = emptyList(),
    val equivalences: List<SpendingEquivalence> = emptyList(),
    val highlightPreview: String? = null,
    val equivalencePreview: SpendingEquivalence? = null,
)

@Serializable
data class PublicShareDocument(
    val ownerId: String,
    val reportId: String,
    val createdAt: Long,
    val expiresAt: Long,
    val snapshot: PublicShareSnapshot,
)

fun generateShareId(): String = buildString {
    val chars = "abcdefghijklmnopqrstuvwxyz0123456789"
    repeat(16) {
        append(chars.random())
    }
}
